import { create } from 'zustand';

export interface Toast {
  id: string;
  type: 'message' | 'dm' | 'friend_request' | 'mention' | 'system';
  title: string;
  body: string;
  avatarUrl?: string | null;
  /** Where to navigate on click */
  action?: {
    type: 'dm' | 'channel';
    userId?: string;
    channelId?: string;
    serverId?: string;
  };
  createdAt: number;
  duration: number; // ms
}

interface ToastState {
  toasts: Toast[];
  addToast: (toast: Omit<Toast, 'id' | 'createdAt'>) => void;
  removeToast: (id: string) => void;
  clearAll: () => void;
}

let counter = 0;

export const useToastStore = create<ToastState>((set) => ({
  toasts: [],

  addToast: (toast) => {
    const id = `toast-${Date.now()}-${++counter}`;
    const newToast: Toast = { ...toast, id, createdAt: Date.now() };
    set((state) => ({
      toasts: [...state.toasts, newToast].slice(-5), // max 5 visible
    }));
  },

  removeToast: (id) => {
    set((state) => ({
      toasts: state.toasts.filter((t) => t.id !== id),
    }));
  },

  clearAll: () => set({ toasts: [] }),
}));
